import m from "../../geodata/es2015/cambodiaHigh";
window.am4geodata_cambodiaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/cambodiaHigh.js
// module id = null
// module chunks = 